import React from "react";

import { _getItemFromSession } from "../../../Utils/Helpers/SessionKeys";

import LoaderWebm from "../../../Assets/Images/finalLoader.webm";
import LoaderGif from "../../../Assets/Images/finalLoader.gif";
import { Spinner, Icon } from "@jds/core";

import "./Loader.scss";
import useTranslation from "../../../Hooks/UseTranslation/use-translation";

enum EDeviceOsType {
  IOS = "3",
  ANDROID = "2",
}

const isSafari =
  (window.navigator.userAgent.indexOf("Safari") !== -1 &&
    window.navigator.userAgent.indexOf("Chrome") === -1 &&
    window.navigator.userAgent.indexOf("Chromium") === -1) ||
  (_getItemFromSession("_pnp") === "true" &&
    _getItemFromSession("device_os_type") === EDeviceOsType.IOS);

const LOADING_MSG = "Loading";
interface ILoader {
  loaderDivClass?: string;
  loaderImgClass?: string;
  smallLoader?: boolean;
  bigLoaderText?: string;
  componentLoader?: boolean;
}

const Loader = ({
  loaderDivClass = "",
  loaderImgClass = "",
  smallLoader = false,
  bigLoaderText = "Loading ...",
  componentLoader = false,
}: ILoader) => {
  const { t } = useTranslation();

  
  if (bigLoaderText.includes(LOADING_MSG)) {
    const index = bigLoaderText.indexOf(LOADING_MSG);
    if (index !== -1) {
      bigLoaderText = bigLoaderText.slice(0, index) + t("LOADING") + bigLoaderText.slice(index + LOADING_MSG.length);
    }
  }

  // console.log("bigLoader Text: ", bigLoaderText)
  return smallLoader === true ? (
    <div className={loaderDivClass}>
      <Spinner
        labelPosition="right"
        size="small"
        appearance="normal"
        // className={`spinnerSmallLoader`}
      />
      {/* {isSafari || _getItemFromSession("_pnp") === "true" ? (
        <img className={loaderImgClass} src={LoaderGif} alt="Loader" />
      ) : (
        <video
          className={loaderImgClass}
          autoPlay
          muted
          loop
          id="baseLoaderVideo"
          height="50px"
          width="50px"
        >
          <source src={LoaderWebm} type="video/webm" />
        </video>
      )} */}
    </div>
  ) : (
    <>
      {!componentLoader ? <div className="base-loader-overlay" /> : <></>}
      <div
        className={
          componentLoader ? "base-loader base-loader-component" : "base-loader"
        }
      >
        <Spinner
          labelPosition="right"
          size="medium"
          appearance="normal"
          // className={`spinnerSmallLoader`}
        />
        {/* {(isSafari || (_getItemFromSession("_pnp") === "true")) ? (
          <img height="50px" width="50px" src={LoaderGif} alt="Loader" />
        ) : (
          <video
            autoPlay
            muted
            loop
            id="baseLoaderVideo"
            height="50px"
            width="50px"
          >
            <source src={LoaderWebm} type="video/webm" />
          </video>
        )} */}
        {bigLoaderText ? (
          <span className="base-loader-text">{bigLoaderText}</span>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Loader;
